import { atom } from 'jotai/vanilla';

import { useAtomValue } from '@/utils/jotai-svelte';

import { CurrentText$ } from './use-current-text';

export const IsCurrentTextSet$ = atom((get) => get(CurrentText$).length > 0);

export const useIsCurrentTextSet = () => useAtomValue(IsCurrentTextSet$);
